import Model from '@/models/Model.js';

export default class CourseTemplateGroup extends Model {
    static entity = 'course_template_group';

    static modelName = 'CourseTemplateGroup';

    static primaryKey = ['course_template_id', 'group_id'];

    static fields() {
        return {
            id: this.attr(null),
            course_template_id: this.attr(null),
            group_id: this.attr(null),

            ...super.fields(),

            course_template: this.belongsTo('course_templates', 'course_template_id'),
            group: this.belongsTo('groups', 'group_id'),
        };
    }
}
